<template>
	<router-view v-slot="{ Component }">
		<div v-if="show" class="layout-system">
			<transition v-bind="layoutTransition">
				<div v-if="layout.component" :key="layoutKey" class="layout-system__layout">
					<component :is="layout.component" v-bind="{ ...layout.props }">
						<transition v-bind="viewTransition">
							<div :key="viewKey" class="layout-system__view">
								<component :is="Component" />
							</div>
						</transition>
					</component>
				</div>
			</transition>
		</div>
	</router-view>
</template>

<script lang="ts">
import { AsyncComponentLoader, Component, computed, defineComponent, PropType } from 'vue';

import { LAYOUT_TRANSITIONS_MAP } from '@/layouts/transitions';
import { VueTransitionVBind } from '@/tools/types';

import { useLayoutSystem } from './composable';

export default defineComponent({
	props: {
		show: {
			type: Boolean,
			default: true,
		},

		defaultLayout: {
			type: [Object, Function] as PropType<Component | AsyncComponentLoader>,
			required: true,
		},
	},

	setup(props) {
		const { ...layoutSystem } = useLayoutSystem(props);

		const layoutTransition: VueTransitionVBind = {};
		const viewTransition = computed((): VueTransitionVBind => {
			const { component } = layoutSystem.layout.value;

			if (component && LAYOUT_TRANSITIONS_MAP.get(component)) {
				return LAYOUT_TRANSITIONS_MAP.get(component) ?? {};
			}

			return {};
		});

		return {
			...layoutSystem,

			layoutTransition,
			viewTransition,
		};
	},
});
</script>

<style lang="scss">
.layout-system {
	&,
	&__layout,
	&__view-wrapper,
	&__view {
		width: 100%;
	}

	&__view {
		display: flex;
		min-height: 100%;

		& > * {
			width: 100%;
		}
	}
}
</style>
